import logo from "./logo.svg";
import "./App.css";
import Navigator from "./Router/Navigator";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { investorApi } from "./api/api";
import { updateSubscription,kycStatus } from "./redux/reducers/userReducer";
import { setThemeData } from "./redux/reducers/themeValueReducer";
import { applyFavicon } from "./utils/favicon";
import BrandThemeProvider from "./theme/BrandThemeProvider";
// import { generateToken , messaging} from "./firebase";
// import { onMessage } from "firebase/messaging";

function App() {
  const userId = useSelector((state) => state.user.userId);
  const user= useSelector((state)=>state.user);
  console.log(user);
  const currentTheme = useSelector((state) => state.themeValue.theme);
  const favicon = useSelector((state) => state.themeValue.logourl.favicon);

  const dispatch = useDispatch();

  // useEffect(()=>{
  //  generateToken(userId);
  //  onMessage(messaging, (payload) => {
  //   console.log(payload);
  //  })
  // },[])

useEffect(() => {
  const fetchTheme = async () => {
    try {
      const themeRes = await investorApi.getThemeColors(currentTheme);
      console.log(themeRes);
      if (themeRes?.data) {
        dispatch(setThemeData(themeRes.data));
        const faviconUrl = themeRes.data.favicon || themeRes.data.light_logo;
        if (faviconUrl) applyFavicon(faviconUrl);
      }
    } catch (err) {
      console.error("Theme fetch error:", err);
    }
  };

  const fetchSubscription = async () => {
    if (!userId) return; // ✅ skip if no user

    try {
      const subscriptionRes = await investorApi.getUserSubscriptionStatus(userId);
      if (subscriptionRes.status === 200) {
        const { isSubscribed, kycStatus: isKyc } = subscriptionRes.data;

        dispatch(updateSubscription({ userId, isSubscribed }));
        dispatch(kycStatus({ userId, isKyc }));
      }
    } catch (err) {
      console.error("Subscription fetch error:", err);
    }
  };

  // ✅ Always call theme
  fetchTheme();

  // ✅ Conditional call
  fetchSubscription();

}, [dispatch, userId, currentTheme]);

  useEffect(() => {
    if (favicon) {
      applyFavicon(favicon);
    }
  }, [favicon]);

  

  return (
    <BrandThemeProvider>
      <Navigator />
    </BrandThemeProvider>
  );
}

export default App;
